import * as React from "react";

const EmailPopover = (
  <div className="email-popover">
    <p>Email recipients will be notified when files are delivered.</p>
  </div>
);

export default EmailPopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/ReportContact/EmailPopover.tsx